import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { translate } from 'react-i18next';

import AssetsFormFilesPreviewRow from 'components/assets/form_sections/AssetsFormFilesPreviewRow';
import AssetsFormFilesRow from 'components/assets/form_sections/AssetsFormFilesRow';

class AssetsFormFilesPreview extends Component {
  static propTypes = {
    uploaded: Proptypes.arrayOf(Proptypes.object),
    files: Proptypes.arrayOf(Proptypes.object).isRequired,
    handleRemove: Proptypes.func.isRequired,
    handleUploadedRemove: Proptypes.func,
    handleFileChange: Proptypes.func,
    t: Proptypes.func.isRequired,
  };

  renderRows = () => [
    ...((this.props.uploaded &&
      this.props.uploaded
        .filter((file) => file.id)
        .map((file, index) => (
          <AssetsFormFilesRow
            key={file.id}
            id={file.id}
            file={file}
            handleRemove={this.props.handleUploadedRemove}
            handleFileChange={this.props.handleFileChange}
          />
        ))) ||
      []),
    ...this.props.files.map((file, index) => (
      <AssetsFormFilesPreviewRow
        key={file.id}
        id={file.id}
        file={file}
        handleRemove={this.props.handleRemove}
        handleFileChange={this.props.handleFileChange}
      />
    )),
  ];

  render = () => (
    <div className="col-sm-12 mb-3 table-responsive">
      <table className="table table-hover table-striped table-sm">
        <thead>
          <tr>
            <th width="30%" className="text-center">
              {this.props.t('files.preview')}
            </th>
            <th width="30%">{this.props.t('files.name')}</th>
            <th width="30%" className="text-center">
              {this.props.t('files.status')}
            </th>
            <th width="10%" className="text-center">
              {this.props.t('files.default')}
            </th>
            <th width="10%">{this.props.t('files.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {!this.props.files.length && (!this.props.uploaded || !this.props.uploaded.length) && (
            <tr>
              <td colSpan="5">
                <div className="alert alert-info text-center mb-0">
                  <i className="fa fa-lg fa-info-circle pr-3" />
                  {this.props.t('files.empty')}
                </div>
              </td>
            </tr>
          )}
          {this.renderRows()}
        </tbody>
      </table>
    </div>
  );
}

export default translate()(AssetsFormFilesPreview);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormFilesPreview.js